import { STEP_CONFIGS } from './constants'

const HEADER_BACKGROUND_EXTRA_PX = 8

export function StepHeader({ stepIndex, isEven, bleedPx = 0 }: { stepIndex: number; isEven: boolean; bleedPx?: number }) {
  const config = STEP_CONFIGS[stepIndex]
  if (!config) return null
  const backgroundExtraPx = stepIndex >= 1 && stepIndex <= 2 ? HEADER_BACKGROUND_EXTRA_PX : 0
  const curveBottom = -bleedPx - backgroundExtraPx - 1

  return (
    <div
      className="relative w-full"
      style={{
        height: config.barHeight + config.curveHeight,
        overflow: 'visible',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          height: config.barHeight + config.curveHeight + bleedPx + backgroundExtraPx,
          background: config.barColor,
        }}
      />
      {/* White curved overlay — curve side inset to A4 boundary, straight side extends to edge */}
      <div
        style={{
          position: 'absolute',
          bottom: curveBottom,
          left: isEven ? 0 : bleedPx,
          right: isEven ? bleedPx : 0,
          height: config.curveHeight + 1,
          background: '#ffffff',
          ...(isEven
            ? { borderTopRightRadius: config.curveHeight }
            : { borderTopLeftRadius: config.curveHeight }),
        }}
      />
    </div>
  )
}
